import type { FC } from 'react';
import { Route } from 'react-router';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageOfferCopy } from 'src/pages/storage/offers-new/copy';
import { StorageOfferCreate } from 'src/pages/storage/offers-new/create';
import { StorageOfferDetails } from 'src/pages/storage/offers-new/details';
import { StorageOfferReservePriceEdit } from 'src/pages/storage/offers-new/details/allocation-proposal/recalculate';
import { StorageOfferEdit } from 'src/pages/storage/offers-new/edit';
import { StorageOffersOverviewNew } from 'src/pages/storage/offers-new/overview';

export const StorageOffersNewRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/storage/offers-new"
        element={
          <StorageOffersOverviewNew storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/offers-new/:offerId"
        element={
          <StorageOfferDetails storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/offers-new/create"
        element={<StorageOfferCreate storageServiceRoot={storageServiceRoot} />}
      />
      <Route
        path="/storage/offers-new/:offerId/edit"
        element={<StorageOfferEdit storageServiceRoot={storageServiceRoot} />}
      />
      <Route
        path="/storage/offers-new/:offerId/copy"
        element={<StorageOfferCopy storageServiceRoot={storageServiceRoot} />}
      />
      <Route
        path="/storage/offers-new/:offerId/edit-reserve-price"
        element={
          <StorageOfferReservePriceEdit
            storageServiceRoot={storageServiceRoot}
          />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
